// Utilidad para ordenar carreras por nombre (alfabéticamente, insensible a mayúsculas/minúsculas)
export interface RaceWithName {
  nombre: string;
  [key: string]: any;
}

export function sortRacesByName<T extends RaceWithName>(races: T[]): T[] {
  return [...races].sort((a, b) =>
    a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' })
  );
}
